import React from 'react';

interface Props {
  providers: React.FC<unknown & { children: React.ReactNode }>[];
  children: React.ReactNode;
}

export const Provider = ({ providers, children }: Props) => {
  return providers.reduce((Prev, Curr) => <Curr>{Prev}</Curr>, children) as JSX.Element;
};
